import AxiosBase from "../axios/AxiosBase";

export const getSubsctiption = (email, captchaToken, b_hp_email) => {
  return new Promise((resolve, reject) => {
    AxiosBase.post("/mentee/subscription", { email, captchaToken, b_hp_email })
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
};


export const submitContactUs = (form) => {
  return new Promise((resolve, reject) => {
    AxiosBase.post("/mentee/contact_us", form)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const submitCorporateEnrollment = (form) => {
  return new Promise((resolve, reject) => {
    AxiosBase.post("/mentee/corporate_enrollment", form)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
};


export const submitFreeTrial= (form) => {
  return new Promise((resolve, reject) => {
    AxiosBase.post("/mentee/freeTrial", form)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
